import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['strata_convergence_maplayer'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("convergence map layer");
      this.appendValueInput("vis_params")
          .setCheck(null)
          .setVisible(false);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour('#53565a');
      this.setStyle("dasboards")
      this.setTooltip("");
      this.setHelpUrl("");
    },

}